import React, {useState} from "react";
import { gcBookingReviewScreen, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import AutoSuggest from "../../../../../shared/components/autosuggest/autosuggest";
import InputField from "../../../../core-components/InputFeild/InputFeildUI";
import * as S from "./PickupAddress.styles";
import { MOB_CABS_REVIEW, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE, EXACT_LOCATION_NEEDED } from "../../../../../shared/utils/util-constants";
import { CTA_TYPE } from "../../../../../shared/utils/omni-utils";
import CheckBox from "../../../../core-components/Checkbox/Checkbox";
import { USE_AS_BILLING_ADDRESS_TAX } from "../../../../../shared/config/constants";

const Widget = ({ autosuggestRef, props, inputRef, label, type }) => {
  return (
    <S.InputWrapper>
      <InputField
        ref={autosuggestRef}
        labelText={"Enter Pickup Location"}
        margin="0 0 1.7rem 0"
        autoCompleteProp="off"
        {...props}
      /> 
    </S.InputWrapper>
	);
}

const PickupAddressUI = ({
  heading,
  cityName,
  address,
  cta,
	margin,
	source,
  handleMap,
  onSuggestUpdate = () => { },
  isAdreesUpdate = "",
  exactLocationApplicable = false,
  displayGstin = false,
  sourceAsGstin,
  isLoggedIn = false,
  onGstinSameSourceCheckbox = (bool) => {}
}) => {
  const [exactLocationEventFired, setExactLocationEventFired] = useState(false)
  React.useEffect(() => {
    if (exactLocationApplicable && !exactLocationEventFired) {
      setExactLocationEventFired(true)
      pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${EXACT_LOCATION_NEEDED}`, CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
    }
  }, [exactLocationApplicable, exactLocationEventFired])
  return (
    <S.PickupAddr margin={margin}>
      {heading && <h3>{heading}</h3>}
      {cityName && <p className="cityName">{cityName}</p>}
			<AutoSuggest
				widget={Widget}
				label={"source"}
        labelVal={"From"}
				title={source}
        popularSearch={[]}
        onSuggestUpdate={onSuggestUpdate}
        invokedFor={gcBookingReviewScreen}
      />
      {isAdreesUpdate ? <S.SuccessMessage color={exactLocationApplicable ? 'red' : ''}>{isAdreesUpdate}</S.SuccessMessage> : null}
      {displayGstin && !isLoggedIn ? (
        <S.SourceAsGstinCheckboxCont isAddressUpdate={isAdreesUpdate}>
          <CheckBox 
            title={USE_AS_BILLING_ADDRESS_TAX}
            checked={sourceAsGstin}
            onClickCb={() => onGstinSameSourceCheckbox(!sourceAsGstin)}
          />
        </S.SourceAsGstinCheckboxCont>
      ) : null}

    </S.PickupAddr>
  );
};

export default PickupAddressUI;
